module.exports = __webpack_public_path__ + "assets/forklift.svg?e8bcfaa17e9d2e0e741d38f6f0472fae";